export enum ResultReason {
    TECH_LOSS_NO_OPPONENT = 'NOT_COME_ON_TIME',
    TECH_LOSS_OPPONENT_FALSE_START = 'OPPONENT_FALSE_START',
    TECH_LOSS_OPPONENT_INJURED = 'INJURED_UP_TO_THE_END_OF_MATCH',
    TECH_LOSS_OPPONENT_DISQUALIFIED = 'DISQUALIFIED_FROM_TOURNAMENT',
    TECH_LOSS_OTHER = 'OTHER',
    TIE_ACCURACY = 'ACCURACY',
    TIE_RANK = 'RANK',
    REGULAR = 'REGULAR',
}
